<form [formGroup]="formGroup">
<div class="row">
  <div [class.col-12]="!inline" [class.col-3]="inline">
    <label class="form-label" >{{placeholder}}</label>
  </div>
  <div [class.col-12]="!inline" [class.col-9]="inline">
    <div class="row">
      <div class="col-12 col-md-6">
        <app-date-time
          class="w-100"
          name="{{ name }}_min"
          [formControl]="$any(formGroup.controls.min)"
          [timeMode]="TIME_MODE.START_OF_DAY"
          [placeholder]="'table_filter.from_date_placeholder' | translate"
          [small]="true"
        ></app-date-time>
      </div>
      <div class="col-12 col-md-6">
        <app-date-time
          class="w-100"
          name="{{ name }}_max"
          [formControl]="$any(formGroup.controls.max)"
          [timeMode]="TIME_MODE.END_OF_DAY"
          [placeholder]="'table_filter.until_date_placeholder' | translate"
          [small]="true"
        ></app-date-time>
      </div>
    </div>
  </div>
</div>
</form>

